import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, EnvelopeIcon, MapPinIcon, ClockIcon } from '@heroicons/react/24/outline';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="flex flex-col">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/images/gallery/cropped-Logo-1.png" 
                alt="Plenco Logo" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-primary-200 mb-4 leading-relaxed text-sm">
              Specialized in plumbing, tank calibration, general engineering, 
              building construction, renovation works and general contracts.
            </p>
            <div className="flex space-x-4 mb-4">
              <a href="https://www.facebook.com/people/Plenco-Plumbing-Construction-Company-Ltd/100088949889828/" target="_blank" rel="noopener noreferrer" className="text-primary-200 hover:text-white transition-colors" aria-label="Facebook">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://x.com/PlencoPlumbingC" target="_blank" rel="noopener noreferrer" className="text-primary-200 hover:text-white transition-colors" aria-label="Twitter/X">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/96765788" target="_blank" rel="noopener noreferrer" className="text-primary-200 hover:text-white transition-colors" aria-label="LinkedIn">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
            <p className="text-primary-300 font-semibold mt-auto">Serving East Africa since 2013</p>
          </div>
          
          <div className="flex flex-col">
            <h3 className="text-lg font-black mb-4 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-primary-200 hover:text-white transition-colors font-medium">Home</Link></li>
              <li><Link to="/about" className="text-primary-200 hover:text-white transition-colors font-medium">About Us</Link></li>
              <li><Link to="/services" className="text-primary-200 hover:text-white transition-colors font-medium">Services</Link></li>
              <li><Link to="/projects" className="text-primary-200 hover:text-white transition-colors font-medium">Projects</Link></li>
              <li><Link to="/gallery" className="text-primary-200 hover:text-white transition-colors font-medium">Gallery</Link></li>
              <li><Link to="/contact" className="text-primary-200 hover:text-white transition-colors font-medium">Contact</Link></li>
            </ul>
          </div>
          
          <div className="flex flex-col">
            <h3 className="text-lg font-black mb-4 text-white">Services</h3>
            <ul className="space-y-3">
              <li><span className="text-primary-200 font-medium">General Plumbing</span></li>
              <li><span className="text-primary-200 font-medium">Tank Calibration</span></li>
              <li><span className="text-primary-200 font-medium">Building Construction</span></li>
              <li><span className="text-primary-200 font-medium">Renovation Works</span></li>
              <li><span className="text-primary-200 font-medium">General Contracts</span></li>
            </ul>
          </div>
          
          <div className="flex flex-col">
            <h3 className="text-lg font-black mb-4 text-white">Contact Info</h3>
            <div className="space-y-2.5">
              <div className="flex items-start space-x-3">
                <MapPinIcon className="h-5 w-5 mt-0.5 flex-shrink-0 text-primary-300" />
                <span className="text-primary-200 text-sm leading-snug">
                  Kansanga, Ggaba Rd, Near KIU World Saloon Building<br/>
                  Basement Floor, Room B05<br/>
                  P.O Box 148303, Kampala, Uganda
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <PhoneIcon className="h-5 w-5 flex-shrink-0 text-primary-300" />
                <a href="tel:+256200906397" className="text-primary-200 hover:text-white transition-colors font-medium text-sm">+256 200 906397 | +256 704 485986 | +256 786 272003</a>
              </div>
              <div className="flex flex-col space-y-1.5">
                <div className="flex items-center space-x-3">
                  <EnvelopeIcon className="h-5 w-5 flex-shrink-0 text-primary-300" />
                  <a href="mailto:info@plencoplumbingltd.com" className="text-primary-200 hover:text-white transition-colors font-medium text-sm break-all">info@plencoplumbingltd.com</a>
                </div>
                <div className="flex items-center space-x-3">
                  <EnvelopeIcon className="h-5 w-5 flex-shrink-0 text-primary-300 opacity-0" />
                  <a href="mailto:plencoplumbing@gmail.com" className="text-primary-200 hover:text-white transition-colors font-medium text-sm break-all">plencoplumbing@gmail.com</a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <ClockIcon className="h-5 w-5 mt-0.5 flex-shrink-0 text-primary-300" />
                <span className="text-primary-200 text-sm leading-snug">
                  Mon - Fri: 8:00AM - 6:00PM, Sat: 9:00AM - 3:00PM
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-primary-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-center md:text-left">
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 justify-center md:justify-start">
              <p className="text-primary-300">&copy; {new Date().getFullYear()} Plenco Plumbing & Construction Co. Ltd. All rights reserved.</p>
              <span className="hidden sm:inline text-primary-300">|</span>
              <p className="text-primary-300">Designed by <a href="https://nuemadigitalmarketing.com/" target="_blank" rel="noopener noreferrer" className="text-primary-200 font-semibold hover:text-white transition-colors">Nuema Digital</a></p>
            </div>
            <div className="flex justify-center md:justify-end gap-6 text-sm">
              <a href="#" className="text-primary-300 hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="text-primary-300 hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="text-primary-300 hover:text-white transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
